import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly user: UserService, private readonly router: Router,
    private readonly sessionService: SessionService,) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.user.accessToken();
    if (!token && !req.withCredentials) {
      return next.handle(req);
    }

    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
//errorCode
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!(error instanceof HttpErrorResponse)) {
          return throwError(() => error);
        }
        
        if (error.status !== 401) {
          return throwError(() => error);
        }
        
        // If refresh itself failed -> hard logout
        if (error.error?.code === 'RefreshTokenFailed') {
          this.user.remove();
          this.router.navigate(['/auth/login']);
          return throwError(() => error);
        }

        // If no token at all, just logout
        if (!this.user.accessToken()) {
          this.user.remove();
          this.router.navigate(['/auth/login']);
          return throwError(() => error);
        }

        // Try refresh then retry original request once
        return from(this.sessionService.refreshToken()).pipe(
          switchMap(() => {
            const newToken = this.user.accessToken();
            if (!newToken) {
              this.user.remove();
              this.router.navigate(['/auth/login']);
              return throwError(() => error);
            }

            const retryReq = req.clone({
              setHeaders: { Authorization: `Bearer ${newToken}` }
            });

            return next.handle(retryReq);
          }),
          catchError((refreshErr) => {
            this.user.remove();
            this.router.navigate(['/auth/login']);
            return throwError(() => refreshErr);
          })
        );
      })
    );;
  }
}
